import * as Yup from 'yup'
import { t } from 'translations'

type ValidationSchema = {
    productName: Yup.StringSchema
    regularPrice: Yup.NumberSchema
    minPrice: Yup.NumberSchema
    maxPrice: Yup.NumberSchema
    rounding: Yup.StringSchema
    gatePrice?: Yup.NumberSchema
    priceVariation: Yup.StringSchema
}

export default Yup.object<ValidationSchema>().shape({
    dynamicPricing: Yup.boolean(),
    productName: Yup.string().required(),
    regularPrice: Yup.number()
        .typeError(() => t('products.pricing.pricingForm.validation.invalidNumber'))
        .required()
        .min(0)
        .max(9999)
        .test('regularPrice', () => t('products.pricing.pricingForm.validation.regularAboveGate'), function (value: number) {
            const { gatePrice } = this.parent
            return !gatePrice || value <= gatePrice
        }),
    minPrice: Yup.number().when('dynamicPricing', {
        is: true,
        then: Yup.number()
            .typeError(() => t('products.pricing.pricingForm.validation.invalidNumber'))
            .required()
            .min(0)
            .max(9999)
            .max(Yup.ref('regularPrice'), () => t('products.pricing.pricingForm.validation.minAboveRegular'))
            .max(Yup.ref('maxPrice'), () => t('products.pricing.pricingForm.validation.minAboveMax'))
            .test('minPrice', () => t('products.pricing.pricingForm.validation.minAboveRegularOrEqual'), function (value: number) {
                const { regularPrice } = this.parent
                return regularPrice >= value
            })
            .test('minPrice', () => t('products.pricing.pricingForm.validation.minAboveGate'), function (value: number) {
                const { gatePrice } = this.parent
                return !gatePrice || value <= gatePrice
            }),
    }),
    maxPrice: Yup.number().when('dynamicPricing', {
        is: true,
        then: Yup.number()
            .typeError(() => t('products.pricing.pricingForm.validation.invalidNumber'))
            .required()
            .min(0)
            .max(9999)
            .min(Yup.ref('minPrice'), () => t('products.pricing.pricingForm.validation.maxBelowMin'))
            .test('maxPrice', () => t('products.pricing.pricingForm.validation.maxBelowRegular'), function (maxPrice: number) {
                const { regularPrice } = this.parent
                return regularPrice <= maxPrice
            })
            .test('maxPrice', () => t('products.pricing.pricingForm.validation.maxAboveGate'), function (maxPrice: number) {
                const { gatePrice } = this.parent
                return !gatePrice || maxPrice <= gatePrice
            })
            .test('maxPrice', () => t('products.pricing.pricingForm.validation.maxBelowMin'), function (maxPrice: number) {
                const { minPrice, dynamicPricing } = this.parent
                return !dynamicPricing || minPrice < maxPrice
            }),
    }),
    priceVariation: Yup.string().when('dynamicPricing', {
        is: true,
        then: Yup.string().required(),
    }),
    rounding: Yup.string(),
    gatePrice: Yup.number()
        .nullable()
        .transform((value) => (isNaN(value) ? null : value))
        .min(0)
        .max(9999),
})
